/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Alreadyregistered2Inputs */

const id_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah Terdaftar`)
};

const ms_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah Didaftarkan`)
};

const da_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allerede Registreret`)
};

const de_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits registriert`)
};

const en_us2_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Registered`)
};

const es_es2_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya registrado`)
};

const es_mx2_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya registrado`)
};

const fil_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naka-rehistro Na`)
};

const fr_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà inscrit`)
};

const it_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Già registrato`)
};

const hu_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Már regisztrált`)
};

const nl_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al geregistreerd`)
};

const no_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allerede registrert`)
};

const pl_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Już zarejestrowany`)
};

const pt_br2_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Registered`)
};

const pt_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já registado`)
};

const ro_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja înregistrat`)
};

const fi_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jo rekisteröitynyt`)
};

const sv_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redan registrerad`)
};

const vi_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đăng ký`)
};

const tr_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten Kayıtlı`)
};

const cs_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Již zaregistrováno`)
};

const bg_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вече сте регистрирани`)
};

const ru_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уже зарегистрирован`)
};

const uk_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вже зареєстровано`)
};

const ar_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسجل بالفعل`)
};

const hi_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले से पंजीकृत`)
};

const th_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงทะเบียนแล้ว`)
};

const ja_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録済み`)
};

const zh_cn2_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Registered`)
};

const zh_hant1_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Registered`)
};

const ko_forms_androidbeta_alreadyregistered2 = /** @type {(inputs: Forms_Androidbeta_Alreadyregistered2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already Registered`)
};

/**
* | output |
* | --- |
* | "Already Registered" |
*
* @param {Forms_Androidbeta_Alreadyregistered2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_alreadyregistered2 = /** @type {((inputs?: Forms_Androidbeta_Alreadyregistered2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Alreadyregistered2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "ms") return ms_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "da") return da_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "de") return de_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "fil") return fil_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "fr") return fr_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "it") return it_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "hu") return hu_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "nl") return nl_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "no") return no_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "pl") return pl_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "pt") return pt_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "ro") return ro_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "fi") return fi_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "sv") return sv_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "vi") return vi_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "tr") return tr_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "cs") return cs_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "bg") return bg_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "ru") return ru_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "uk") return uk_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "ar") return ar_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "hi") return hi_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "th") return th_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "ja") return ja_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_alreadyregistered2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_alreadyregistered2(inputs)
	return ko_forms_androidbeta_alreadyregistered2(inputs)
});
export { forms_androidbeta_alreadyregistered2 as "forms.androidBeta.alreadyRegistered" }